module.exports = __webpack_public_path__ + "static/media/Bell2.39d687ba.svg";